/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-29 10:33:30
 *
 *******************************************************/

import _ from 'lodash';
import noProductImage from 'src/assets/images/product/no-product-image.png';
import { optimizeImage } from 'src/helpers';

// imageObject {
//   'key - number': 'url'
// }

/**
 * Pick first image from image object
 *
 * @param  {imageObject} imageObject
 *
 * @return {string} url image
 */
export function pickImage(imageObject, size = '40x40') {
  let result = _.isEmpty(imageObject)
    ? noProductImage
    : optimizeImage(imageObject[Object.keys(imageObject)[0]], size);
  return result;
}


export function pickImageNatural(imageObject) {
  let result = _.isEmpty(imageObject)
    ? noProductImage
    : imageObject[Object.keys(imageObject)[0]]
  return result;
}
